import { RcClasses } from '../../../../foundation';
export var RcStepLabelClasses = RcClasses([
    'disabled',
    'label',
    'active',
    'alternativeLabel',
    'labelContainer',
    'error',
], 'RcStepLabel');
